import { render, staticRenderFns } from "./PacketLibrary.vue?vue&type=template&id=0b89cf56&scoped=true&"
import script from "./PacketLibrary.vue?vue&type=script&lang=ts&"
export * from "./PacketLibrary.vue?vue&type=script&lang=ts&"
import style0 from "./PacketLibrary.vue?vue&type=style&index=0&id=0b89cf56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89cf56",
  null
  
)

export default component.exports